import { formatDateTimeSeconds, parseUtcMs } from "@/utils/datetime";

// admin Storage 화면(운영 회수 표면)의 셀 표기 헬퍼. 표시 규칙만 가진다. 데이터 적재는 다루지 않는다.

// uuid 앞 8자만 표시한다(테이블 폭 절약). 운영자는 이 prefix 로 로그/DB를 조회한다.
export function shortUuid(uuid: string): string {
  return uuid.length > 8 ? uuid.slice(0, 8) : uuid;
}

// 회수 대상의 마지막 변경 시각. 운영자가 이 값을 다른 리전 기록과 대조한다. 그래서 초와 뷰어
// offset 까지 표시한다. 값이 없거나 파싱할 수 없으면 빈 칸 문자를 반환한다.
export function formatStorageTimestamp(isoTimestamp: string | null): string {
  return formatDateTimeSeconds(parseUtcMs(isoTimestamp));
}
